import { useTranslation } from 'react-i18next';
import { InfiosAlert, InfiosIcon } from '@infios/uikit/react';
import type { AgentErrorData } from '../../interfaces/chat';

interface AgentErrorBlockProps {
  data: AgentErrorData;
}

export function AgentErrorBlock({ data }: AgentErrorBlockProps) {
  const { t } = useTranslation();

  return (
    <InfiosAlert variant="danger" open>
      <InfiosIcon slot="icon" name="alert-circle" />
      {t('ChatbotUI.OrderBlocks.ErrorHeading')}
      {data.retryable ? <p>{t('ChatbotUI.OrderBlocks.ErrorRetryable')}</p> : null}
    </InfiosAlert>
  );
}
